// --------------------------------------------------------------
// Created On: 2023-08-19
// Author: Zachary Thomas
//
// Last Modified: 2024-02-09
// Modified By: Zachary Thomas
//
// Copyright 2023 - 2024 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------
import { SUPER_ADMIN_PERMISSION } from "../constants/permissions";
import store from "../redux/store";

// Checks if the current user has permission to perform an action.
export default function userHasPermission(requiredPermissions: string[][]): boolean {
  const storeState = store.getState();

  if (
    storeState !== undefined &&
    storeState.currentUser !== undefined &&
    storeState.currentUser.permissions !== undefined
  ) {
    const currentUserPermissions = storeState.currentUser.permissions;

    // Skip all other checks if the user has SUPER_ADMIN permissions.
    if (currentUserPermissions.includes(SUPER_ADMIN_PERMISSION)) {
      return true;
    }

    for (let i = 0; i < requiredPermissions.length; i++) {
      const requiredPermissionSet = requiredPermissions[i];
      let passedChecks = 0;

      for (let j = 0; j < requiredPermissionSet.length; j++) {
        const requiredPermission = requiredPermissionSet[j];
        if (currentUserPermissions.includes(requiredPermission)) {
          passedChecks++;
        }
      }

      if (passedChecks === requiredPermissionSet.length) {
        return true;
      }
    }
  }

  return false;
}
